import { render, staticRenderFns } from "./RwLoader2.vue?vue&type=template&id=240edf7a"
import script from "./RwLoader2.vue?vue&type=script&lang=js"
export * from "./RwLoader2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/indsol-advisor/indsol-advisor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('240edf7a')) {
      api.createRecord('240edf7a', component.options)
    } else {
      api.reload('240edf7a', component.options)
    }
    module.hot.accept("./RwLoader2.vue?vue&type=template&id=240edf7a", function () {
      api.rerender('240edf7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RwLoader2.vue"
export default component.exports